import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'
import { Box, List, ListItem, ListItemIcon, Typography } from '@mui/material'

import { useAppContext } from '@/hooks'

import type { ImportProgress } from '../../../types'

interface ImportErrorContentProps {
	progress: ImportProgress
}

export const ImportErrorContent = ({ progress }: ImportErrorContentProps) => {
	const { t } = useAppContext()

	return (
		<Box className="text-center">
			<ErrorIcon color="error" sx={{ fontSize: 64 }} className="mb-4" />
			<Typography variant="h6" className="mb-2">
				{t('IMPORT_SQL_ERROR')}
			</Typography>
			<Typography variant="body2" color="error" className="mb-4">
				{progress.error}
			</Typography>

			{(progress.completedSteps?.length ?? 0) > 0 && (
				<Box className="mt-4">
					<Typography variant="body2" color="text.secondary" className="mb-2">
						Completed steps before failure:
					</Typography>
					<List dense>
						{(progress.completedSteps ?? []).map((stepDesc, i) => (
							<ListItem key={i}>
								<ListItemIcon>
									<CheckCircleIcon color="success" fontSize="small" />
								</ListItemIcon>
								<Typography variant="body2">{stepDesc}</Typography>
							</ListItem>
						))}
					</List>
				</Box>
			)}

			{(progress.stepErrors?.length ?? 0) > 0 && (
				<Box className="mt-4">
					<Typography variant="body2" color="error" className="mb-2">
						⚠️ Step Errors:
					</Typography>
					<List dense>
						{(progress.stepErrors ?? []).map((stepError, i) => (
							<ListItem key={i}>
								<ListItemIcon>
									<ErrorIcon color="error" fontSize="small" />
								</ListItemIcon>
								<Box>
									<Typography variant="body2">{stepError.stepDescription}</Typography>
									<Typography variant="caption" color="error">
										{stepError.error}
									</Typography>
								</Box>
							</ListItem>
						))}
					</List>
				</Box>
			)}
		</Box>
	)
}

